import api from '../apis/api';
import getMessageFromApiError from '../util/getMessageFromApiError';

export const fetchLlmConfigs = async () => {
  try {
    const res = await api.get('/job/llm/configs');
    return res.data;
  } catch (error) {
    const message = getMessageFromApiError(error);
    throw new Error(`API Error - ${message}`);
  }
};

